export default __webpack_public_path__ + "static/media/7.19d69bf1.png";